import { useNavigate } from "react-router";

import { useListDataWithLoadMore } from "../../../hooks";
import { GET_MEDICAL_INSTITUTIONS } from "../../../graphql/queries";
import {
  MedicalInstitutionProps,
  MedicalInstitutionPage as Component,
} from "../../../components/pages/medicalInstitution/MedicalInstitutionPage";

export const MedicalInstitutionPage = () => {
  const navigate = useNavigate();

  const {
    data,
    variables: { keyword, order },
    handlers: { onSearchClick, onResetClick, onSortClick, onLoadMoreClick },
  } = useListDataWithLoadMore(
    GET_MEDICAL_INSTITUTIONS,
    "medicalInstitutions",
    "医療機関情報は全て表示されています",
  );

  if (!data?.medicalInstitutions) {
    return null;
  }

  const props: MedicalInstitutionProps = {
    medicalInstitutions: data.medicalInstitutions,
    searchValue: keyword,
    order,
    onLoadMoreClick,
    onSearchClick,
    onResetClick,
    onSortClick,
    onRowClick: (medicalInstitutionId: string) =>
      navigate(`/medicalInstitution/${medicalInstitutionId}`),
  };

  return <Component {...props} />;
};
